import React from "react";
import ReactDOM from "react-dom";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Enrolment,
  PatientEnrolment,
  PatientEnrolmentBookEyeCheck,
} from "../components/enrolment";
import ScrollToTop from "../lib/ScrollToTop.ts";

import Activations from "../pages/activations";
import ProviderSearch from "../pages/provider_search";

const { gaTrackingId } = JSON.parse(
  document.getElementById("react-root").getAttribute("data"),
);

const csrfMeta = document.querySelector("meta[name=csrf-token]");
const csrfToken = csrfMeta ? csrfMeta.content : "";

const Root = ({ csrfToken }) => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route
        exact
        path="/enrolments/new"
        element={
          <Enrolment
            csrfToken={csrfToken}
            gaTrackingId={gaTrackingId}
            gtag={window.gtag}
          />
        }
      />
      <Route
        exact
        path="/patient_enrolments/new"
        element={<PatientEnrolment csrfToken={csrfToken} />}
      />
      <Route
        exact
        path="/patient_enrolments/book_eye_check"
        element={
          <PatientEnrolmentBookEyeCheck
            gaTrackingId={gaTrackingId}
            csrfToken={csrfToken}
          />
        }
      />
      <Route
        path="/activations/*"
        element={<Activations csrfToken={csrfToken} />}
      />
      <Route
        exact
        path="/provider_search/*"
        element={<ProviderSearch csrfToken={csrfToken} />}
      />
    </Routes>
  </BrowserRouter>
);

document.addEventListener("DOMContentLoaded", () => {
  const props = { csrfToken };

  ReactDOM.render(
    <Root {...props} />,
    document
      .querySelector("#react-root")
      .appendChild(document.createElement("div")),
  );

  tippy.setDefaultProps({
    arrow: true,
    delay: 40,
    theme: "keepsight",
    interactive: true,
    aria: {
      content: "describedby",
      expanded: "auto",
    },
    allowHTML: true,
  });

  tippy(".field-tip-new");
});
